// extracted by mini-css-extract-plugin
export default {"loaderContainer":"PreviousAnswersLoader_loaderContainer__Fb8rl"};